<div [@showSidebar]="!ready" id="custom-sidebar"
  class="opacity-0 w-full hide-scrollbar transition-spring-500ms backdrop-blur-2xl fixed  h-screen max-h-screen  {{ !isMobile ? ( expanded  ? 'rounded-r-2xl sidebar-desktop ' : 'sidebar-expanded') : (expanded  ? 'sidebar-mobile' : 'sidebar-expanded')}} ">

  <div class=" flex flex-col justify-start transition-all duration-300" style="height: 100%;max-height: 100dvh;">
    <!--Logo-->
    <div [@expandCollapseSidebarLogo]="expanded || isMobile"
      class="relative flex flex-col justify-center items-center my-2 transition-all duration-300"
      style="max-height: 14%;">
      <a class="logo-main p-2" routerLink="/home/dashboard" (click)="onNodeSelected('')">
        <img src="{{logoPath}}" class="logo-main" alt="logo" id="app-logo-sidebar" #appLogo>
        <!--<img src="assets/images/temp/LogoSera-black.svg" class="mr-2 logo-main"
        alt="logo">-->
      </a>
    </div>
    <!-- <div class=" border-b-2 border-primary-200 w-full"></div>-->
    <!-- User info -->
    <div 
      class="{{expanded ? 'hidden' : ''}} userCard shadow-medium rounded-3xl mx-2 overflow-hidden transition-all duration-300 bg-white/10 w-auto text-primary-500 text-start user-card ">
      <div class="flex justify-between items-center">


        <div [routerLink]="'/home/user/info'"
          class="flex items-center rounded-xl w-1/6 cursor-pointer transition-all duration-300  m-2">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
          </svg>

        </div>

        <div id="username" class="flex flex-col text-center  w-4/6">

          <p class=" text-xl font-medium whitespace-nowrap text-ellipsis overflow-hidden">{{user?.username}}</p>


          <!-- <span id="roles" class="text-xs whitespace-nowrap text-ellipsis overflow-hidden">
            @for (role of userData.roles; track role; let i = $index) {
            <span>{{role}}@if (i < userData.roles.length -1) { <span>, </span>
            } </span>
          }
          </span> -->
        </div>


        <!--     <button [matMenuTriggerFor]="menu">Menu</button> -->

        <!-- <div tabindex="0" [matMenuTriggerFor]="menu"
      class="flex items-center text-primary-500 hover:bg-primary-500 hover:text-white rounded-xl  p-2 cursor-pointer transition-all duration-300 ">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="w-6 h-6">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 5l0 14" />
        <path d="M5 12l14 0" />
      </svg>

      </div> -->

        <div (click)="showButton()" class=" w-1/6 m-2 cursor-pointer">

          <div class="p-2 w-full flex justify-center items-center {{displayOptions ? 'rotate-180' : '-rotate-180'}}"
            style="transition: all var(--springEaseIn300ms);">
            @if (!displayOptions) {
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            }

            @if (displayOptions) {
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
            </svg>
            }
          </div>

        </div>


      </div>
      <div @slideDownUpFastLeave *ngIf="displayOptions" class="flex flex-col text-center" id="options">
        <div
          class="flex items-center gap-2 text-primary-500 border-b-2 border-primary-500/20 hover:bg-primary-700 hover:text-white  w-full  p-2 cursor-pointer transition-all duration-300 "
          (click)="settings()">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
            <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
          </svg>
          <p class="whitespace-nowrap text-ellipsis overflow-hidden">Impostazioni</p>
        </div>
        <div
          class="flex items-center gap-2 w-full text-red-500 hover:bg-red-500 hover:text-white rounded-b-2xl  p-2 cursor-pointer transition-all duration-300 "
          (click)="logout()">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2" />
            <path d="M15 12h-12l3 -3" />
            <path d="M6 15l-3 -3" />
          </svg>
          <p class="whitespace-nowrap text-ellipsis overflow-hidden">Esci</p>
        </div>
      </div>
    </div>





    <!--Menu-->
    <div class="relative overflow-auto w-full mt-4 px-1 hide-scrollbar  transition-all duration-300 menu-expanded">
      <!--<app-menu>

    </app-menu>
    <div class="my-4"></div>-->

      @if (data.length) {


      <app-tree [expanded]="expanded" [data]="data" #tree (onNodeClick)="onNodeSelected($event)">
      </app-tree>


      }
      @if (data.length == 0) {
      <div class="text-left flex justify-around items-start h-full ">
        <!--<div class=" lds-dual-ring ">
      </div>-->
        <div class="flex flex-col mt-4">
          @for (_ of [].constructor(15); track $index) {
          <div class="loading-place-holder text-left flex mt-3">
            <div class="p-0.5 rounded-full bg-elevation animate-pulse w-full">&nbsp;</div>
          </div>
          }
        </div>
      </div>
      }

    </div>

  </div>



  <!-- <div
class="flex justify-center items-center gap-2 w-full p-2"
style="max-height: 10vh;">


<div tabindex="0"
  class="flex items-center text-primary-500 hover:bg-primary-500 hover:text-white rounded-xl w-12 h-12  border-primary-500 border-2  p-2 cursor-pointer transition-all duration-300 "
  (click)="settings()">
  <svg xmlns="http://www.w3.org/2000/svg" class="w-full h-fit" viewBox="0 0 24 24" stroke-width="1.5"
    stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path
      d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
      <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
    </svg>

  </div>


  <div *ngIf="!expanded" tabindex="0"
    class="flex items-center border-red-500 border-2 w-12 h-12 text-red-500 hover:bg-red-500 hover:text-white rounded-xl  p-2 cursor-pointer transition-all duration-300 "
    (click)="logout()">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" class="w-full h-fit">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
      <path d="M9 12h12l-3 -3" />
      <path d="M18 15l3 -3" />
    </svg>

  </div>




</div> -->



</div>